import { render } from "./detail-pay-record.vue?vue&type=template&id=045c7f4f&ts=true"
import script from "./detail-pay-record.vue?vue&type=script&lang=ts"
export * from "./detail-pay-record.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__